module.exports = __webpack_public_path__ + "img/pr1-album.8681c2a1.jpg";